<template>   
<div class="app-wrapper" style="height: 100%">     <TopHeader />     <!-- <TopNav /> -->     <router-view class="content-box" />     <Bottom  v-show="!$route.meta.shieldBottom" />   
</div> </template>

<script>
import TopHeader from '@/components/TopHeader'
import Bottom from '@/components/Bottom'
// import TopNav from "@/components/TopNav";
export default {
  name: 'Layout',
  components: {
    TopHeader,
    Bottom
    // TopNav,
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.content-box {
  min-height: calc(100% - 172px);
}
</style>
